import type { DevControlPort } from "./DevControlPort";
import type { PixiPresentationTicker } from "@slot/presentation";

/**
 * Pauses / steps the PRESENTATION ticker. Everything presentation-timed
 * (the runner, hosted Spines, frame players) hangs off it, so a pause freezes the round exactly
 * while Pixi keeps rendering (chrome stays live).
 */
export class PixiDevControlPort implements DevControlPort {
  public constructor(private readonly ticker: PixiPresentationTicker) {}

  public togglePause(): void {
    this.ticker.setPaused(!this.ticker.isPaused());
  }

  public isPaused(): boolean {
    return this.ticker.isPaused();
  }

  public stepFrame(): void {
    // Advance exactly one frame, then stay paused (also pauses if it wasn't).
    this.ticker.setPaused(true);
    this.ticker.stepFrame();
  }
}
